var version = {
    "name":      "dativery",
    "buildDateCode": "20260727-121320",
    "buildDate": "Mon Jul 27 2026 12:13:20 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260727-121320",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;